export default __webpack_public_path__ + "static/media/turn-slight-right.515854fe.svg";